import React, { useEffect } from "react";
import "./css/HomePage.css";

const ContentSkeleton = ({ printMode = false }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className={`container ${printMode ? "content-print-shell" : ""}`}
      style={{ marginTop: "2rem" }}
      aria-busy="true"
      aria-label="Loading bhajan content"
    >
      {/* Top Breadcrumb & Actions Toolbar Skeleton */}
      <div className="col-md-12">
        <div className="d-flex justify-content-between align-items-center content-toolbar-wrap mb-4">
          <div
            className="skeleton-box"
            style={{ width: "160px", height: "20px", borderRadius: "4px" }}
          >
            <div className="skeleton-pulse" />
          </div>
          <div className="d-flex align-items-center gap-2">
            <div
              className="skeleton-box"
              style={{ width: "76px", height: "34px", borderRadius: "999px" }}
            >
              <div className="skeleton-pulse" />
            </div>
            <div
              className="skeleton-box"
              style={{ width: "76px", height: "34px", borderRadius: "999px" }}
            >
              <div className="skeleton-pulse" />
            </div>
          </div>
        </div>
      </div>

      {/* Main Title Skeleton */}
      <div className="row mt-4 mb-3">
        <div className="col text-center">
          <div className="content-skeleton-title skeleton-box">
            <div className="skeleton-pulse" />
          </div>
        </div>
      </div>

      {/* Main Bhajan Lyrics Text Lines Skeleton (Text only, no media placeholders) */}
      <div className="content-skeleton-lyrics text-center my-4">
        {[80, 65, 75, 55, 85, 70, 60, 80, 65, 75, 50].map((width, idx) => (
          <div
            key={idx}
            className="content-skeleton-line skeleton-box"
            style={{
              width: `${width}%`,
              maxWidth: "640px",
              marginBottom: idx % 4 === 3 ? "1.5rem" : "0.75rem",
            }}
          >
            <div className="skeleton-pulse" />
          </div>
        ))}
      </div>

      {/* Related Section Skeleton (Pre-allocated for CLS prevention) */}
      {!printMode && (
        <div className="row mt-5">
          <div className="col">
            <div
              className="skeleton-box mx-auto mb-3"
              style={{ width: "130px", height: "26px", borderRadius: "6px" }}
            >
              <div className="skeleton-pulse" />
            </div>
            <div className="row gy-3 row-cols-1 row-cols-md-2 mt-2">
              {[1, 2, 3, 4].map((i) => (
                <div className="col" key={i}>
                  <div
                    className="card h-100 shadow-sm border-0 skeleton-box"
                    style={{ minHeight: "56px", borderRadius: "8px" }}
                  >
                    <div className="skeleton-pulse" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContentSkeleton;

